import React from 'react';
import { Loading } from '../../../Shared/components/Loading/Loading';
import styles from './styles.module.css';

export const LoadingQuotes = () => (
  <div className={styles.main}>
    <div className={styles.content}>
      <div>
        <div className={styles.spinner}>
          <Loading />
        </div>
        <div>Loading Quotes...</div>
      </div>
    </div>
  </div>
);
